<template>
  <div :class="this.styleOptions">
    <div class="metric-card" :style="{height: this.height + '' + 'px'}">
      <p class="name">{{ ( metric.name ? metric.name : '' ) | sentenceCase | truncate(50) }}</p>
      <p class="metric" :class="isText ? 'metric__text' : ''">{{ metricValue }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    metric: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 120
    },
    styleOptions: {
      type: String,
      default: 'col-xs-12 col-sm-6 col-md-3'
    }
  },

  computed: {
    increase () {
      if (this.metric.percentage) {
        if (this.metric.percentage === 0) {
          return 100
        }
        return ((this.metric.percentage * 100) - 100).toFixed(2)
      }
    },

    isText () {
      return this.metric.metric !== null && isNaN(this.metric.metric)
    },

    metricValue () {
      if (!this.metric.metric) {
        return 0
      }
      if (isNaN(this.metric.metric)) {
        return this.metric.metric
      }
      return Math.round(this.metric.metric)
    }
  }
}
</script>
